<template>
  <div class="card-situation-resource">
    <div>
      <card-header :title="title" />
    </div>
    <div class="data-container" v-if="data.cpuUsedRate || data.qps">
      <div class="row-item">
        <template>
          <div>
            <div class="name">
              {{ data.subTitle[0] }}
            </div>
            <div class="number-item" v-show="data.qps">
              <countTo
                :startVal="0"
                :endVal="data.qps"
                :duration="2000"
                :decimals="1"
                :key="componentKey"
              ></countTo>
            </div>
            <div class="show-item" v-show="!data.qps">
              <gauge-chart-situation
                :key="componentKey"
                :usedData="data.cpuUsedRate"
              />
            </div>
          </div>
        </template>
      </div>
      <div class="row-item">
        <template>
          <div>
            <div class="name">
              {{ data.subTitle[1] }}
            </div>
            <div class="number-item" v-show="data.subTitle[1] === '响应时间(ms)'">
              <countTo
                :startVal="0"
                :endVal="data.returnTime"
                :duration="2000"
                :decimals="1"
                :key="componentKey"
              ></countTo>
            </div>
            <div class="show-item" v-show="data.subTitle[1] === '内存使用率'">
              <gauge-chart-situation
                :key="componentKey"
                :usedData="data.memoryUsedRate"
              />
            </div>
          </div>
        </template>
      </div>
      <div class="row-item">
        <template>
          <div>
            <div class="name">
              {{ data.subTitle[2] }}
            </div>
            <div
              class="number-item"
              v-show="['响应时间(ms)', 'upstream响应时间(ms)'].indexOf(data.subTitle[2]) > -1"
            >
              <countTo
                :startVal="0"
                :endVal="data.upstreamReturnTime || data.returnTime"
                :duration="2000"
                :decimals="1"
                :key="componentKey"
              ></countTo>
            </div>
            <div class="show-item" v-show="data.subTitle[2] === '硬盘使用率'">
              <gauge-chart-situation
                :key="componentKey"
                :usedData="data.diskUsedRate"
              />
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import countTo from 'vue-count-to';
import CardHeader from './card-header.vue';
import GaugeChartSituation from './gauge-chart-situation.vue';

export default {
  components: {
    CardHeader,
    GaugeChartSituation,
    countTo,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    data: {
      type: Object,
      required: true,
      default: () => {},
    },
    isRefresh: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      componentKey: 0,
    };
  },
  watch: {
    isRefresh() {
      // eslint-disable-next-line no-underscore-dangle
      // console.log(this._uid);
      this.forceRerender();
    },
  },
  methods: {
    forceRerender() {
      if (this.isRefresh) {
        this.componentKey += 1;
      }
    },
  },
};
</script>
<style lang="scss">
.card-situation-resource {
  box-sizing: border-box;
  min-width: 470px;
  min-height: 148px;
  padding: 8px 14px 17px;
  margin: 0 1px 5px;
  background-image: url("../../../assets/screen-adapter/最近7天供应商排名统计.png");
  background-size: 100% 100%;

  background-repeat: no-repeat;
  .data-container {
    padding-top: 13px;
    padding-bottom: 4px;
    display: flex;
    justify-content: flex-start;
    flex-wrap: nowrap;
    .row-item {
      position: relative;
      width: 198px;
      height: 96px;
      &:last-child {
        margin-right: 0;
      }
      .name {
        font-size: 14px;
        font-weight: bold;
        color: #66ffff;
      }
      .show-item {
        position: absolute;
        bottom: -20px;
        font-weight: bold;
      }
      .number-item {
        margin-top: 35px;
        font-size: 20px;
        font-weight: bold;
        color: #fff;
      }
    }
  }
}
</style>
